var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66663 5.83398L8.47073 10.5969C9.0217 10.9825 9.29719 11.1754 9.59685 11.2501C9.86154 11.3161 10.1384 11.3161 10.4031 11.2501C10.7027 11.1754 10.9782 10.9825 11.5292 10.5969L18.3333 5.83398M5.66663 16.6673H14.3333C15.7334 16.6673 16.4335 16.6673 16.9683 16.3948C17.4387 16.1552 17.8211 15.7727 18.0608 15.3023C18.3333 14.7675 18.3333 14.0674 18.3333 12.6673V7.33398C18.3333 5.93385 18.3333 5.23379 18.0608 4.69901C17.8211 4.2286 17.4387 3.84615 16.9683 3.60647C16.4335 3.33398 15.7334 3.33398 14.3333 3.33398H5.66663C4.26649 3.33398 3.56643 3.33398 3.03165 3.60647C2.56124 3.84615 2.17879 4.2286 1.93911 4.69901C1.66663 5.23379 1.66663 5.93385 1.66663 7.33398V12.6673C1.66663 14.0674 1.66663 14.7675 1.93911 15.3023C2.17879 15.7727 2.56124 16.1552 3.03165 16.3948C3.56643 16.6673 4.26649 16.6673 5.66663 16.6673Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.848d397afa60ddf5be601a92beb73718.svg";
export { ForwardRef as ReactComponent };